module.exports = __webpack_public_path__ + "img/Icons for SPIM Sidebar-55.1e5c6d4a.svg";